import {Api, ApiExport} from '../../Api.js'

const RESOURCE = 'person'

export default {
    resource: RESOURCE,
    export(query, filename) {

        /*
        return window.axios({
            url: window.axios.defaults.baseURL + '/' + this.resource + '/export' + (query ? query : ''),
            method: 'GET',
            responseType: 'blob', // important
        });*/

        return ApiExport(filename).get(this.resource + '/export' + (query ? query : ''),
            {
                responseType: 'blob', // important
            });
    },
    all(query) {
        return Api().get(this.resource + '/all'  + (query ? query : '') )
    },
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    import(data) {
        return Api().post(this.resource + '/import', data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    },
    getStats(period) {
        return Api().get(this.resource + '/stats?period=' + period )
    },
    getAllUser(query){
        return Api().get(this.resource + '/user/all'  + (query ? query : '') )
    }
}


// WEBPACK FOOTER //
// ./src/modules/person/PersonService.js